export function calculateAge(
  birthdate: string | Date | null | undefined,
  asOfDate: Date = new Date()
): number | null {
  if (!birthdate) {
    return null;
  }

  const birthdateValue = new Date(birthdate);
  const asOfDateValue = new Date(asOfDate);

  if (
    Number.isNaN(birthdateValue.getTime()) ||
    Number.isNaN(asOfDateValue.getTime())
  ) {
    return null;
  }

  let age =
    asOfDateValue.getFullYear() - birthdateValue.getFullYear();
  const birthdayThisYear = new Date(
    asOfDateValue.getFullYear(),
    birthdateValue.getMonth(),
    birthdateValue.getDate()
  );

  if (asOfDateValue < birthdayThisYear) {
    age -= 1;
  }

  return age >= 0 ? age : null;
}
